<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-container>
      <b-row>
        <b-col>
          <v-card>
            <v-card-title> IMPORTAR RESIDENTES </v-card-title>
            <v-card-text>
              <b-form @submit.prevent="evOnSubmit">
                <b-row>
                  <b-col>
                    <label-required-field label="DOCUMENTO(S)" />
                    <b-form-file
                      :disabled="loading"
                      v-model="files"
                      multiple
                      placeholder="SELECIONE OU ARRASTE ARQUIVOS AQUI (LibreOffice Calc, Excel ou CSV)."
                      drop-placeholder="SOLTE O(S) ARQUIVO(S) AQUI..."
                      browse-text="PROCURAR"
                      accept=".xls, .xlsx, .csv, .ods"
                    />
                  </b-col>
                </b-row>
                <b-row v-if="results.length > 0">
                  <b-col>
                    <v-card>
                      <v-card-title> Erros </v-card-title>
                      <v-card-text>
                        <errors-messages
                          :errors="[
                            'Nenhum arquivo foi importado. Corrija as seguintes informações para continuar',
                          ]"
                        />
                        <b-row>
                          <b-col>
                            <v-expansion-panels>
                              <v-expansion-panel
                                v-for="(result, index) in results"
                                :key="index"
                              >
                                <v-expansion-panel-header>
                                  {{ result.filename }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <b-row v-if="result.reason">
                                    <b-col>
                                      <errors-messages
                                        :errors="[result.reason]"
                                      />
                                    </b-col>
                                  </b-row>
                                  <b-row v-if="result.sheets.length > 0">
                                    <b-col>
                                      <b-card no-body>
                                        <b-tabs card>
                                          <b-tab
                                            v-for="(
                                              sheet, index
                                            ) in result.sheets"
                                            :key="index"
                                            :title="sheet.name"
                                          >
                                            <b-card-text>
                                              <b-row v-if="sheet.reason">
                                                <b-col>
                                                  <errors-messages
                                                    :errors="[sheet.reason]"
                                                  />
                                                </b-col>
                                              </b-row>
                                              <b-row
                                                v-if="sheet.rows.length > 0"
                                              >
                                                <b-col>
                                                  <v-data-table
                                                    dense
                                                    :headers="[
                                                      {
                                                        text: 'Entidade',
                                                        value: 'body',
                                                      },
                                                      {
                                                        text: 'Motivo',
                                                        value: 'reason',
                                                      },
                                                    ]"
                                                    :items="sheet.rows"
                                                  >
                                                    <template
                                                      v-slot:[`item.reason`]="{
                                                        item,
                                                      }"
                                                    >
                                                      {{ item.reason }}
                                                    </template>
                                                    <template
                                                      v-slot:[`item.body`]="{
                                                        item,
                                                      }"
                                                    >
                                                      <div
                                                        v-for="(
                                                          key, index
                                                        ) in Object.keys(
                                                          item.body
                                                        )"
                                                        :key="index"
                                                      >
                                                        <span>
                                                          {{ key }}:
                                                          {{ item.body[key] }}
                                                        </span>
                                                      </div>
                                                    </template>
                                                  </v-data-table>
                                                </b-col>
                                              </b-row>
                                            </b-card-text>
                                          </b-tab>
                                        </b-tabs>
                                      </b-card>
                                    </b-col>
                                  </b-row>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </b-col>
                        </b-row>
                      </v-card-text>
                    </v-card>
                  </b-col>
                </b-row>
                <errors-messages :errors="errors" />
                <b-row align-h="end">
                  <b-col cols="auto">
                    <v-btn
                      :disabled="loading"
                      :loading="loading"
                      class="btn-save"
                      type="submit"
                    >
                      <i class="fas fa-file-upload mr-2 text-twenty" /> IMPORTAR
                    </v-btn>
                  </b-col>
                </b-row>
              </b-form>
            </v-card-text>
          </v-card>
        </b-col>
      </b-row>
      <v-btn
        v-if="$route.query.stock_item_total"
        :loading="loading"
        :disabled="loading"
        @click="stockItemTotal"
        >stockItemTotal</v-btn
      >
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import LabelRequiredField from "../templates/Components/LabelRequiredField.vue";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "Import",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    LabelRequiredField,
  },

  data() {
    return {
      results: [],

      files: [],

      loading: false,

      errors: [],
    };
  },

  methods: {
    // Aqui esta chamadno o Back-End
    async evOnSubmit() {
      try {
        this.loading = true;

        this.errors = [];
        if (this.files.length == 0) {
          this.errors.push("Escolha um ou mais arquivos para continuar");
          this.loading = false;
          return;
        }

        let formData = new FormData();
        for (const file of this.files) formData.append("file", file);

        let response = await api.post("/import/residents/execute", formData);

        let { error, errors, message, results } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.results = results;
          toast(message, "success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async stockItemTotal() {
      try {
        this.loading = true;

        let response = await api.post("/rest-home/execute/stock-item-total");

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
